export interface IBulletinBranding {
  ecoleId: string;
  headerText: string | null;
  footerText: string | null;
  logoPresent: boolean;
  signaturePresent: boolean;
  professeurPrincipalSignaturePresent: boolean;
}

export const defaultValue: IBulletinBranding = {
  ecoleId: '',
  headerText: null,
  footerText: null,
  logoPresent: false,
  signaturePresent: false,
  professeurPrincipalSignaturePresent: false,
};
